export default "__VITE_ASSET__Bu1cL2vZ__"